import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FeatureKey} from '@core/helpers/fn/feature-constants.enum';
import {
	FeatureKeyLabelPipe,
	FileSizePipe,
	DurationPipe,
	TranslatePipe,
} from '@shared/pipes';
import {UsageItem, UsageTier, usageTier} from './feature-usage.types';

@Component({
	standalone: true,
	selector: 'green-feature-usage-bar',
	imports: [
		CommonModule,
		TranslatePipe,
		FeatureKeyLabelPipe,
		FileSizePipe,
		DurationPipe,
	],
	templateUrl: './feature-usage-bar.component.html',
	styleUrls: ['./feature-usage-bar.component.scss'],
})
export class FeatureUsageBarComponent {
	@Input({required: true}) item!: UsageItem;
	@Input() labelKey?: string;

	get tier(): UsageTier {
		return usageTier(this.item?.percentage ?? 0, !!this.item?.unlimited);
	}

	get displayPercentage(): number {
		const raw = Math.min(100, Math.max(0, this.item?.percentage ?? 0));
		return Math.round(raw);
	}

	get isStorage(): boolean {
		return this.item?.key === FeatureKey.StorageSpace;
	}

	get isEncodingMinutes(): boolean {
		return this.item?.key === FeatureKey.EncodingMinutes;
	}

	get isDuration(): boolean {
		return (
			this.item?.key === FeatureKey.EncodingMinutes ||
			this.item?.key === FeatureKey.MaxVideoDuration
		);
	}

	get tierClass(): string {
		return {
			ok: 'tier-ok',
			warn: 'tier-warn',
			danger: 'tier-danger',
			muted: 'tier-muted',
		}[this.tier];
	}

	get isGroupItem(): boolean {
		return !!this.item?.is_group || (this.item?.feature_count ?? 0) > 1;
	}

	get useRawFeatureName(): boolean {
		return !this.labelKey && this.isGroupItem && !!this.item?.feature_name;
	}
}
